/* tslint:disable */
import {
  Vendor
} from '../index';

declare var Object: any;
export interface AttributeGroupInterface {
  "vendorId"?: any;
  "attributes": Array<any>;
  "status"?: number;
  "updatedAt"?: Date;
  "updatedBy"?: any;
  "id"?: any;
  vendor?: Vendor;
}

export class AttributeGroup implements AttributeGroupInterface {
  "vendorId": any;
  "attributes": Array<any>;
  "status": number;
  "updatedAt": Date;
  "updatedBy": any;
  "id": any;
  vendor: Vendor;
  constructor(data?: AttributeGroupInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AttributeGroup`.
   */
  public static getModelName() {
    return "AttributeGroup";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AttributeGroup for dynamic purposes.
  **/
  public static factory(data: AttributeGroupInterface): AttributeGroup{
    return new AttributeGroup(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AttributeGroup',
      plural: 'AttributeGroups',
      path: 'AttributeGroups',
      idName: 'id',
      properties: {
        "vendorId": {
          name: 'vendorId',
          type: 'any'
        },
        "attributes": {
          name: 'attributes',
          type: 'Array&lt;any&gt;'
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        vendor: {
          name: 'vendor',
          type: 'Vendor',
          model: 'Vendor',
          relationType: 'belongsTo',
                  keyFrom: 'vendorId',
          keyTo: 'id'
        },
      }
    }
  }
}
